import moment from "moment";

export const toLowerCaseNonAccentVietnamese = (str) => {
  str = str.toLowerCase();
  // We can also use this instead of from line 11 to line 17
  // str = str.replace(/\u00E0|\u00E1|\u1EA1|\u1EA3|\u00E3|\u00E2|\u1EA7|\u1EA5|\u1EAD|\u1EA9|\u1EAB|\u0103|\u1EB1|\u1EAF|\u1EB7|\u1EB3|\u1EB5/g, "a");
  // str = str.replace(/\u00E8|\u00E9|\u1EB9|\u1EBB|\u1EBD|\u00EA|\u1EC1|\u1EBF|\u1EC7|\u1EC3|\u1EC5/g, "e");
  // str = str.replace(/\u00EC|\u00ED|\u1ECB|\u1EC9|\u0129/g, "i");
  // str = str.replace(/\u00F2|\u00F3|\u1ECD|\u1ECF|\u00F5|\u00F4|\u1ED3|\u1ED1|\u1ED9|\u1ED5|\u1ED7|\u01A1|\u1EDD|\u1EDB|\u1EE3|\u1EDF|\u1EE1/g, "o");
  // str = str.replace(/\u00F9|\u00FA|\u1EE5|\u1EE7|\u0169|\u01B0|\u1EEB|\u1EE9|\u1EF1|\u1EED|\u1EEF/g, "u");
  // str = str.replace(/\u1EF3|\u00FD|\u1EF5|\u1EF7|\u1EF9/g, "y");
  // str = str.replace(/\u0111/g, "d");
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  // Some system encode vietnamese combining accent as individual utf-8 characters
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
  return str;
};

export const toConvertUrl = (str) => {
  const textNonAccentVietnamese = toLowerCaseNonAccentVietnamese(
    str?.trim() || ""
  );
  let result = textNonAccentVietnamese.replace(/\s/g, "-");
  result = result.replace("---", "-");
  return result;
};

export const toConvertNameNonAccentVN = (str) => {
  return toLowerCaseNonAccentVietnamese(str).replace(/(^|\s)\S/g, function (l) {
    return l.toUpperCase();
  });
};

export const toConvertDateFromString = (str) => {
  return dayjs(str, "YYYY-MM-DD");
};

export const toSearchParams = (name, value = "", isMultiple = false) => {
  const searchParams = new URLSearchParams(window.location?.search);
  if (isMultiple) {
    searchParams.delete(name);
    if (value?.length !== 0) {
      value?.forEach?.((e) => {
        searchParams.append(name, e);
      });
    }
  } else {
    if (searchParams.has(name)) {
      searchParams.set(name, value);
    } else {
      searchParams.append(name, value);
    }
  }

  return searchParams.toString();
};

export function formatMoney(
  amount,
  decimalCount = 0,
  decimal = ",",
  thousands = "."
) {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    let j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
      (decimalCount
        ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
        : "")
    );
  } catch (e) {
    throw e;
  }
}
export function checkValidEmail(email) {
  return /^\w+([.+-]+?\w+)*@\w+([.+-]+?\w+)*(\.\w{2,3})+$/.test(email);
}

export function checkValidPhone(phone) {
  const regexPhoneNumber = /^(\+)*([0-9]+)\b/g;
  return !!phone.match(regexPhoneNumber);
}

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function renderLocaleText(
  data = null,
  locale = "en",
  fields = ["name", "english_name"]
) {
  if (!data) {
    return "";
  }

  return locale === "vn" ? data?.[fields[0]] : data?.[fields[1]];
}

export function formatTime(val, format) {
  if (!val) {
    return "";
  }
  return moment(val).format(format);
}
